import { GA4Utilities, LocationUtilities, SiteUtilities } from './utils';

const getKafkaPayload = (data, queue) => ({
  method: 'POST',
  data: JSON.stringify({
    account_id: '123', // random account number - mandatory field
    payload: {
      user: data
    },
    payload_type: queue
  }),
  contentType: 'application/json',
  url: 'https://alfred.freshworks.com/v1/hawk-eye'
});

const postToKafka = (payload) => {
  try {
    $.ajax(payload);
  } catch (e) {
  }
};

const sendUserActivityPulse = async () => {
  try {
    const data = {
      currentUrl: window.location.href.split('?')[0],
      latestPageVisits: localStorage.getItem('latest_page_visits') || null,
      ga: await SiteUtilities.pollUntilTruthy(GA4Utilities.getGAId, 500, 20)
    };
    const payload = getKafkaPayload(data, 'lead-activity-alert');
    postToKafka(payload);
  } catch (e) {}
};

const sendDemandbasePulse = async (companyProfile, countryName) => {
  try {
    const data = {
      currentUrl: window.location.href.split('?')[0],
      companyProfile,
      ga: await SiteUtilities.pollUntilTruthy(GA4Utilities.getGAId, 500, 20),
      countryName
    };
    const payload = getKafkaPayload(data, 'demandbase-enrichment-alert');
    postToKafka(payload);
  } catch (e) {}
};

const init = () => {
  SiteUtilities.pollUntilTruthy(() => window.OptanonActiveGroups && window.OptanonActiveGroups.includes('C0004'), 500, 20)
    .then(targettingCookiesAllowed => {
      if (targettingCookiesAllowed) {
        sendUserActivityPulse();
        LocationUtilities.onLocationReady((geoLocation, { countryName }) => {
          if (countryName) {
            window.demandbaseDataReceived = (companyProfile) => sendDemandbasePulse(companyProfile, countryName);
          }
        });
      }
    });
};

export default { init };
